import { useQuery } from '@tanstack/react-query';
import { get, api } from '../../lib/api';

export const useGetVaultFiles = ({
  page,
  itemsPerPage,
  showAll,
  sortBy,
  sortDirection,
  category,
}) => {
  const params = {
    page,
    limit: itemsPerPage,
    show_all: showAll,
    sort_by: sortBy,
    sort_direction: sortDirection,
    category: category,
  };

  const { data = { vaultFiles: [] }, isLoading } = useQuery(
    ['vaultFiles', params],
    () => get('/api/client_admin/vault_files', params),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    },
  );

  return {
    data,
    isLoading,
  };
};

export const deleteVaultFile = ({ vaultFileId }) => {
  return api({
    method: 'delete',
    url: `/api/client_admin/vault_files/${vaultFileId}`,
  });
};

export const updateVaultFile = ({
  vaultFileId,
  displayName,
  vaultCategoryId,
  vendorNames,
}) => {
  const data = {};
  if (displayName !== undefined) data.display_name = displayName;
  if (vaultCategoryId !== undefined) data.vault_category_id = vaultCategoryId;
  if (vendorNames !== undefined) data.vendor_names = vendorNames;

  return api({
    method: 'patch',
    url: `/api/client_admin/vault_files/${vaultFileId}`,
    data: {
      vault_file: data,
    },
  });
};

export const useGetVaultCategories = () => {
  const { data = { categories: [] }, isLoading } = useQuery(
    ['vaultCategories'],
    () => get('/api/client_admin/vault_categories'),
    { refetchOnWindowFocus: false },
  );

  return { data, isLoading };
};

export const createVaultCategory = ({ name, icon }) => {
  return api({
    method: 'post',
    url: '/api/client_admin/vault_categories',
    data: { vault_category: { name, icon } },
  });
};

export const updateVaultCategory = ({ categoryId, name, icon }) => {
  const data = {};
  if (name !== undefined) data.name = name;
  if (icon !== undefined) data.icon = icon;

  return api({
    method: 'patch',
    url: `/api/client_admin/vault_categories/${categoryId}`,
    data: { vault_category: data },
  });
};

export const deleteVaultCategory = ({ categoryId }) => {
  return api({
    method: 'delete',
    url: `/api/client_admin/vault_categories/${categoryId}`,
  });
};
